var reqAnimFrame = window.requestAnimationFrame || function(fn) {
	setTimeout(fn, 16);
};

var now;

if (window.performance && typeof window.performance.now === 'function') {
	now = window.performance.now.bind(window.performance);
} else {
	now = function() {
		return +(new Date);
	};
}

function animate(applyFn, callback, easing, values, duration, start) {

	var time = now();
	if (!start) start = time;

	time = (time - start) / duration;
	reqAnimFrame(function() {

		var computedValues = values.map(function(value) {
			return easing ? easing(value, time) : time * value;
		});

		applyFn(computedValues);
		if (time < 1) {
			animate(applyFn, callback, easing, values, duration, start);
		} else {
			applyFn(values);
			if (callback) callback();
		}
	});
}

function to(nodes, duration, properties) {

	//"sometimes" Globals variable are undefined in IE
	if (typeof Array === 'undefined') return;

	duration = 1000 * duration;

	if (!(nodes instanceof Array)) nodes = [nodes];

	var propertiesNames = Object.keys(properties);
	var propertiesValues = propertiesNames.map(function(name) {
		return properties[name];
	});

	animate(function(values) {
		var ext;
		propertiesNames.forEach(function(prop, index) {
			ext = (prop === 'top' || prop === 'left' || prop === 'width' || prop === 'height') ? 'px' : '';
			nodes.map(function(n) {
				// if (prop === 'opacity') {
				// 	if (n) n.style.display = (values[index] === 0) ? 'none' : 'block';
				// }
				if (n) n.style[prop] = values[index] + ext;
			});
		});
	}, properties.onComplete, null, propertiesValues, duration); //TODO properties.opacity loop ?

}

module.exports = {
	to: to,
	animate: animate
};
